module.exports = __webpack_public_path__ + "img/nim_charge_logo.461466da.png";